<template>
  <div class="prefixes">
    <h2>Number of top offending IP addresses:</h2>
    <ul :class="{ 'two-col': topIPs.length > 5 }">
      <li v-for="ip in topIPs" :key="ip.ip">
        <span class="ip">{{ ip.ip }}</span>
        {{ ip.count }} hits
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import mixin from '../../../utils/mixin';
export default {
  mixins: [mixin],
  computed: {
    ...mapGetters('dataStore', ['getPrefixDataOfDashServer']),
    topIPs() {
      const prefixData = this.getPrefixDataOfDashServer;
      const ipMap = new Map();

      prefixData &&
        prefixData.data &&
        prefixData.data.forEach(i => {
          const sourceIP = i['sourceIP'];

          if (sourceIP) {
            sourceIP.forEach(j => {
              const ip = ipMap.get(j.ip);
              if (ip) {
                ip.count += j.count;
              } else {
                ipMap.set(j.ip, { count: j.count, ip: j.ip });
              }
            });
          }
        });
      const ips = [...ipMap.values()];
      ips.sort((a, b) => b.count - a.count);
      return ips.slice(0, 10);
    }
  }
};
</script>

<style lang="scss" scoped>
ul {
  list-style: none;

  &.two-col {
    columns: 2;
  }

  li {
    font-size: 18px;
    margin-bottom: 8px;
    font-weight: 300;

    .ip {
      display: inline-block;
      min-width: 150px;
      font-weight: 600;
    }
  }
}
</style>
